import { useTranslation } from 'react-i18next';
import { DASHBOARD_URL } from '../env';

export default function CTA() {
  const { t } = useTranslation();

  return (
    <section className="border-t border-slate-800/50">
      <div className="relative mx-auto max-w-4xl px-6 py-20 text-center md:py-28 overflow-hidden">
        {/* Subtle glow */}
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="h-[300px] w-[500px] rounded-full bg-emerald-500/5 blur-3xl" />
        </div>
        <h2 className="relative font-display text-3xl font-bold tracking-tight md:text-4xl">
          {t('cta.heading')}
        </h2>
        <p className="relative mt-4 text-slate-400">
          {t('cta.subheading')}
        </p>
        <a
          href={`${DASHBOARD_URL}/register`}
          className="relative mt-8 inline-block rounded-lg bg-emerald-500 px-8 py-3 text-sm font-medium text-slate-950 hover:bg-emerald-400 transition-colors"
        >
          {t('cta.getStartedFree')}
        </a>
      </div>
    </section>
  );
}
